/**
 * Static, local page content for the Team page (L'équipe). Like the Press page, all copy/data lives
 * here so the page stays self-contained and reviewable — the redesign carries no dynamic/DB data.
 */

export type ValueCardVariant = 'yellow' | 'blue' | 'pink' | 'mint'
export type ValueCardIcon = 'bulb' | 'people' | 'megaphone' | 'star'

export type ValueCard = {
  icon: ValueCardIcon
  variant: ValueCardVariant
  title: string
  body: string
  /** Resting tilt (deg) for the sticker look; straightens on hover. */
  rotate: number
}

/** The four "what drives us" value cards, in display order. */
export const VALUE_CARDS: ValueCard[] = [
  {
    icon: 'bulb',
    variant: 'yellow',
    rotate: -1.2,
    title: 'Porteurs de sens',
    body: 'Chaque décision, chaque fonctionnalité, chaque partenariat est pensé pour avoir un impact positif sur les créateurs et les entrepreneurs que nous accompagnons.',
  },
  {
    icon: 'people',
    variant: 'blue',
    rotate: 0.8,
    title: 'Collectif avant tout',
    body: 'Les meilleures idées émergent de la diversité des points de vue. On débat, on construit ensemble. La création de lien social est au cœur de notre démarche.',
  },
  {
    icon: 'megaphone',
    variant: 'pink',
    rotate: -0.6,
    title: 'Passion du terrain',
    body: 'Nos équipes sont au contact direct des porteurs de projets, en France et dans le monde, à l’écoute de vos projets pour leur donner un MAX de chances de succès.',
  },
  {
    icon: 'star',
    variant: 'mint',
    rotate: 0.6,
    title: 'B Corp depuis 2015',
    body: 'Ulule est certifiée B Corp. Étude d’impact, bilan carbone, politique transparente sur la modération des projets ou sur le traitement des données : on s’engage !',
  },
]

export const MISSION_QUOTE =
  'Notre mission : « Donner à chaque personne le pouvoir d’agir pour un monde plus divers, plus durable, plus ouvert »'
export const MANIFESTO_URL = '/about/ulule/'

export const SOCIAL_LINKS = {
  linkedin: 'https://www.linkedin.com/company/ulule/',
  instagram: 'https://www.instagram.com/ulule/',
}
export const NEWSLETTER_URL = '/newsletter/'
export const DISCOVER_URL = '/pages/discover/'
